<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ 'HEATMAP.MODAL.HEADER' | translate }}:
    <span class="fw-bold">{{ organizationName || ( 'HEATMAP.MODAL.UNKNOWN_ORG' | translate ) }}</span>
    - <span class="text-muted fs-5">{{ month || ( 'HEATMAP.MODAL.UNKNOWN_MONTH' | translate ) }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  <div *ngIf="drillDownData && drillDownData.length > 0; else noData">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm">
        <thead>
          <tr>
            <th scope="col"><strong>{{ 'HEATMAP.MODAL.TABLE.CAMPAIGN' | translate }}</strong></th>
            <th scope="col" class="text-end"><strong>{{ 'HEATMAP.MODAL.TABLE.MINUTES' | translate }}</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let campaign of drillDownData">
            <td>{{ campaign.campaign_name || ( 'HEATMAP.MODAL.NO_CAMPAIGN_NAME' | translate ) }}</td>
            <td class="text-end">{{ formatMinutes(campaign.total_minutes) }}</td>
          </tr>
          <tr class="fw-bold table-group-divider">
            <td>{{ 'HEATMAP.MODAL.TABLE.TOTAL' | translate }}</td>
            <td class="text-end">{{ formatMinutes(totalMinutes) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <ng-template #noData>
    <p class="text-muted text-center p-3">
      {{ 'HEATMAP.MODAL.NO_DATA' | translate }}
    </p>
  </ng-template>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-primary" (click)="activeModal.close('Close click')">
    {{ 'HEATMAP.MODAL.CLOSE' | translate }}
  </button>
</div>
